import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector, useDispatch, batch } from "react-redux";
import { ShimmerSocialPost } from "react-shimmer-effects";

import { generateCifForOffer, getOfferDetails } from "@/api/placeOffer";
import MetaComponent from "@/components/common/MetaComponent";

import PropertyInformation from "./PropertyInformation";
import StaticInfo from "@/components/bid/StaticInfo";
import EditCifDetails from "./EditCifDetails";
import useAuth from "@/components/common/header/useAuth";
import { getCifPageDetail } from "@/api/bid";
import SuccessEditCif from "./editcif/SuccessEditCif";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
} from "@/redux/login/loginSlice";
import BidDeposit from "@/components/bid/BidDeposit";
import { setWinningBidData } from "@/bidFeature/bidSlice";

const EditCifMain = () => {
  const dispatch = useDispatch();

  const metadata = {
    title: "CIF",
  };

  const [cifData, setCifData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [cifCompleted, setCifCompleted] = useState(false);
  // below flag is for winner bidder cif
  const [paymentFlag, setPaymentFlag] = useState(false);
  const [isBidDeposit, setIsBidDeposit] = useState(false);
  const [winningBidlistingId, setWinningBidListingId] = useState("");
  const [winningBidUserEmail, setWinningBidUserEmail] = useState("");
  const user_info = useSelector((state) => state?.user?.user);
  // const winningBidUserEmailId = useSelector(
  //   (state) => state?.bidDeposit?.winningBidData
  // );
  // console.log("winningbiduseremail", winningBidUserEmailId);
  const param = useParams();
  console.log("param are ", param);
  const { documentId } = param;
  console.log("document id is", documentId);
  useEffect(() => {
    getCifPageDetail(documentId).then((res) => {
      // console.log("winning bid res is", res?.data?.data);

      dispatch(setWinningBidData(res?.data?.data));
      // console.log("lstingid", res?.data?.data?.listingId);

      // console.log("payment flag", res?.data?.data?.buyerEmailId);
      setWinningBidUserEmail(res?.data?.data?.buyerEmailId);
      setWinningBidListingId(res?.data?.data?.listingId);
      // this below is required for winner bidder cif and adding the flag isPaymentRequired
      if (res?.data?.data?.isPaymentRequired === "Y") {
        setPaymentFlag(true);
      } else {
        setPaymentFlag(false);
      }

      if (res.data.status === "SUCCESS") {
        setCifData(res?.data);
        setIsLoading(false);
      } else {
        batch(() => {
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
        });
      }
    });
  }, []);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }
  if (isLoading) {
    return (
      <div className="container" style={{ margin: "7rem auto" }}>
        <ShimmerSocialPost type="text" title />
      </div>
    );
  }

  console.log("cifData -> ", cifData);
  return (
    <div className="container" style={{ margin: "7rem auto" }}>
      <MetaComponent meta={metadata} />

      {cifCompleted ? (
        <SuccessEditCif
          commonAttributes={cifData?.data?.propertyDetails?.commonAttributes}
          propertyId={cifData?.data?.propertyDetails?.propertyId}
        />
      ) : (
        <>
          {!isBidDeposit && (
            <>
              {" "}
              <h5 className="text-center mb-3 cifHeader">
                Contact Information Form{" "}
              </h5>
              <PropertyInformation cifData={cifData} />
              <StaticInfo paymentFlag={paymentFlag} />
              <EditCifDetails
                cifData={cifData}
                setCifCompleted={setCifCompleted}
                paymentFlag={paymentFlag}
                setIsBidDeposit={setIsBidDeposit}
                winningBidUserEmail={winningBidUserEmail}
              />
            </>
          )}
          {isBidDeposit && (
            <>
              {" "}
              <h5 className="text-center mb-3 cifHeader">Bid Deposit </h5>
              <PropertyInformation cifData={cifData} />
              <BidDeposit
                paymentFlag={paymentFlag}
                winningBidlistingId={winningBidlistingId}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default EditCifMain;
